const SvgLinkedInIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.23 0H1.77C.8 0 0 .77 0 1.72v20.56C0 23.23.8 24 1.77 24h20.46c.98 0 1.77-.77 1.77-1.72V1.72C24 .77 23.2 0 22.23 0zM7.06 20.45H3.56V9h3.5v11.45zM5.31 7.44c-1.13 0-2.04-.9-2.04-2.02 0-1.13.91-2.04 2.04-2.04s2.05.91 2.05 2.04c0 1.12-.92 2.02-2.05 2.02zm15.14 13.01h-3.51v-5.55c0-1.33-.03-3.03-1.85-3.03-1.85 0-2.13 1.45-2.13 2.94v5.64H9.45V9h3.36v1.56h.05c.47-.89 1.62-1.83 3.33-1.83 3.56 0 4.22 2.34 4.22 5.39v6.33z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgLinkedInIcon;
